import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { UserSessionModel } from '../models/user-session.model';

export class UserTokensApiService extends ApiService {
  static endpoint = 'auth/user-tokens';

  /**
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<UserSessionModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: UserSessionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
